import {TabStyles} from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

export const textWidgetStyle: string = style(
  {
    display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 6
  }
);

export const dialogTextStyle: string = style(
  {
    display: 'flex', flexDirection: 'column', width: '100%', marginTop: 10
  }
);

export const successStyle: string = style(
  {
    color: TabStyles.Colors.Black, textAlign: 'center', fontSize: '20px', fontWeight: 'normal'
  }
);

export const warningStyle: string = style(
  {
    color:TabStyles.Colors.AttentionLight, textAlign: 'center', padding:'6px'
  }
);

export const internalTextFieldStyle: React.CSSProperties = {
  marginBottom: 6, width: '100%', border: 'none'
};

export const buttonStyle: string = style(
  {
    marginTop: 24,
    marginBottom: 18
  }
);

export const tokenSecretTextWidgetStyle: string = style(
  {
    display: 'flex', flexDirection: 'row', width: '100%'
  }
);

export const valueStyle: string = style(
  {
    marginLeft: 10
  }
);
